import AcxChip from "components/UI/AcxChip";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import React from "react";

type LabeledConversationsChipProps = {
    result: string;
};

export const LabeledConversationsChip = observer(function (
    props: LabeledConversationsChipProps,
) {
    const store = useStore(LLMClassifierBuilderStore);

    const labeledConversations = store.labeledConversationCounts?.find(
        (counts) => counts.value === props.result,
    );
    if (!labeledConversations) return null;

    const label = `${store.dataLabelingModule?.name} > ${
        store.dataLabelingQuestion?.questionText
    } > ${props.result}: ${labeledConversations.count} Conversation${
        labeledConversations.count !== 1 ? "s" : ""
    }`;

    return (
        <AcxChip
            size="small"
            color="lightBlue"
            wrapTooltip
            customTooltip={label}
            style={{ textWrap: "wrap", maxWidth: "50dvw" }}
            label={label}
        />
    );
});
